import PrivacyPolicyModal from "./WhereIsIdAdesioneModal"

export default  PrivacyPolicyModal;
